import React from "react";
import { useDispatch } from "react-redux";
import { destroy, Field } from "redux-form";

import { Button, FileUploader } from "capitalrx-components";

import SectionContainer from "@/App/components/SectionContainer";

interface Props {
  formName: string;
  pristine: boolean;
}

const ExcelFileUpload: React.FC<Props> = (props: Props) => {
  const { formName, pristine } = props;
  const dispatch = useDispatch();

  const handleClearFields = (): void => {
    dispatch(destroy(formName));
  };

  const uploadDescription = (
    <div className="excel-upload-description">
      <div className="excel-upload-title">
        Please select and upload a .xlsx file below.
        <div className="excel-upload-description-list">
          <ul>
            <li>You may only upload ONE file.</li>
            <li>Dates must follow this format: MM/DD/YYYY</li>
            <li>
              If there are leading zeros in any field, the file must display these leading zeros. Format the fields as text to ensure that
              the leading zeros are present.
            </li>
          </ul>
        </div>
      </div>
      <Button type="button" color="darkblue">
        Select File
      </Button>
    </div>
  );

  return (
    <div className="file-upload-form-container">
      <SectionContainer headerTitle="Upload File" abilityToClose={false}>
        <div className="row">
          <div className="col">
            <Field
              required={true}
              name="excel_file"
              component={FileUploader}
              label="Upload File"
              placeholder="Upload File"
              id="excel-file"
              fileDescription="excel"
              type="file"
              description={uploadDescription}
              alwaysDisplayDropzone={false}
            />
          </div>
        </div>

        {!pristine && (
          <div className="row">
            <div className="col caprx-h-center-text">
              <Button type="reset" handleClick={handleClearFields} color="darkblue">
                Replace File
              </Button>
            </div>
          </div>
        )}
      </SectionContainer>
    </div>
  );
};

export default ExcelFileUpload;
